import classNames from 'classnames';
import { I18nKey } from 'i18n/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { DateTime } from 'luxon';
import { formatDateFromStr, SHORT_DATE_FORMAT } from 'util/formatDate';

import styles from './styles.module.scss';

interface IprogectedDateProps {
  date: string | undefined
  title: I18nKey['common']
  isOpening?: boolean
}

const ProjectedDateBlock = ({ date, title, isOpening }: IprogectedDateProps) => {
  const { t } = useOTSTranslation('common');

  if (!date) { return null; }

  const currentDate = DateTime.local();
  const closingDate = DateTime.fromJSDate(new Date(date));
  const isUpcomingDate = (currentDate < closingDate && currentDate.plus({ days: 30 }) > closingDate) || isOpening;

  if (isUpcomingDate) {
    return (
      <div className={styles.openStatus}>
        <span className={classNames('h3', styles.h3)}>{t(title)}</span>
        <span className={classNames('h2', styles.h2)}>{formatDateFromStr(date, SHORT_DATE_FORMAT)}</span>
      </div>
    );
  }

  return null;
};

export default ProjectedDateBlock;
